import { usePricingContext } from '@vp/react-pricing-context';
import { ListPrice, Pricing } from '@vp/swan';
import { VATMessage, priceFromFloat } from '@99designs/design-services-common';
import type { Currency } from '@99designs/design-services-common';
import type { Price as PriceType } from '../../types';

interface PriceProps {
    price?: PriceType;
}

export const Price = ({ price }: PriceProps) => {
    const pricingContext = usePricingContext();

    if (!price) {
        return null;
    }

    const amount = pricingContext?.vatInclusive ? price.listPrice.taxed : price.listPrice.untaxed;

    return (
        <Pricing data-testid="price-container">
            <ListPrice>
                {priceFromFloat({ amount, currency: price.currency as Currency })}
            </ListPrice>
            <VATMessage />
        </Pricing>
    );
};
